import { SatelliteDish } from 'lucide-react'

import { EntityCard } from '#app/routes/mocra+/_form+/components/entity-card.tsx'

import { MONITORING_FEED_COPY } from '#app/routes/mocra+/_form+/components/monitoring-feeds/constants.ts'
import {
	formatMonitoringFeedSummary,
	monitoringFeedCardTitle,
	type MonitoringFeedDraft,
} from '#app/routes/mocra+/_form+/components/monitoring-feeds/types.ts'

type Props = {
	readonly feed: MonitoringFeedDraft
	readonly onEdit: () => void
	readonly onRemove?: () => void
	readonly removeDisabled?: boolean
	readonly errors?: readonly string[]
}

export function MonitoringFeedCard({
	feed,
	onEdit,
	onRemove,
	removeDisabled,
	errors,
}: Props) {
	const title = monitoringFeedCardTitle(feed)
	const summary = formatMonitoringFeedSummary(feed)
	const hasErrors = Boolean(errors && errors.length > 0)
	const description = hasErrors ? `${summary} • Needs attention` : summary

	return (
		<EntityCard
			title={title}
			description={description}
			onEdit={onEdit}
			onRemove={onRemove}
			removeDisabled={removeDisabled}
			removeLabel="Remove"
			removeConfirmTitle={MONITORING_FEED_COPY.actions.removeConfirmTitle}
			removeConfirmDescription={
				MONITORING_FEED_COPY.actions.removeConfirmDescription
			}
			icon={
				<SatelliteDish
					className="text-muted-foreground h-3.5 w-3.5"
					aria-hidden="true"
				/>
			}
			className={
				hasErrors
					? 'border-destructive/40 ring-destructive/40 ring-1'
					: undefined
			}
			removeAriaLabel="Remove monitoring feed"
		/>
	)
}
